export default "__VITE_ASSET__3ef3f133__"